
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/authors",
      function () {
        return require("private-next-pages/cleartax.in/authors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/authors"])
      });
    }
  